import React, { useRef, useLayoutEffect } from "react";
import "./slider.css";
import Tooltip from "../tooltip/tooltip.tsx";

interface SliderProps {
  title: string;
  value: number;
  onChange: (value: number) => void;
  onPositionChange?: (centerY: number) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  tooltip?: React.ReactNode;
}

const Slider: React.FC<SliderProps> = ({
  title,
  value,
  onChange,
  onPositionChange,
  min = 0,
  max = 100,
  disabled = false,
  tooltip,
}) => {
  const trackRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (trackRef.current && onPositionChange) {
      const rect = trackRef.current.getBoundingClientRect();
      const centerY = rect.top + rect.height / 2;
      onPositionChange(centerY);
    }
  }, [onPositionChange, value]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(Number(event.target.value));
    }
  };

  const percentage = Math.round(((value - min) / (max - min)) * 100);

  return (
    <div className={`slider-container ${disabled ? "slider-disabled" : ""}`}>
      <div className="slider-header">
        <div className="slider-title-with-tooltip">
          <h4 className="slider-title">{title}</h4>
          {tooltip ? <Tooltip title={title} content={tooltip} /> : null} 
        </div>
        <span className="slider-percentage">{percentage}%</span>
      </div>
      <div className="slider-track-container">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          onChange={handleChange}
          className="slider-input"
          disabled={disabled}
        />
        <div
          ref={trackRef}
          className="slider-track"
          style={
            { "--slider-progress": `${percentage}%` } as React.CSSProperties
          }
        >
          <div className="slider-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default Slider;
